if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.renderCartContentsWithoutOpening(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.renderCartContentsWithoutOpening(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Empêche l'ouverture automatique du tiroir. cart-drawer.js appelle this.open()
      // à l'intérieur d'un setTimeout() dans renderContents(), donc notre restauration
      // de this.cart.open doit elle aussi passer par setTimeout pour s'exécuter APRÈS
      // ce setTimeout interne (et non juste après l'appel synchrone à renderContents).
      renderCartContentsWithoutOpening(response) {
        const originalCartOpen = this.cart.open;
        this.cart.open = function () {};

        this.cart.renderContents(response);

        setTimeout(() => {
          this.cart.open = originalCartOpen;
        });

        const productImage = this.getVisibleProductImage();
        if (productImage) {
          this.flyToCart(productImage);
        }

        const upsellSection = document.querySelector('[data-merch-upsell]');
        if (upsellSection) {
          upsellSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      // Récupère l'image produit actuellement visible sur la fiche (celle de la
      // galerie principale), pour servir de point de départ à l'animation flyToCart.
      getVisibleProductImage() {
        const productInfo = this.closest('product-info') || document;
        return productInfo.querySelector('.product__media-wrapper img');
      }

      // Anime une copie de l'image produit qui "vole" depuis la fiche jusqu'à
      // l'icône panier du header. Fonctionne avec un header en position: fixed
      // car getBoundingClientRect() renvoie déjà des coordonnées viewport,
      // exactement ce dont position: fixed a besoin (aucune compensation de scroll requise).
      flyToCart(imageEl) {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (!cartIcon || !imageEl) return;

        const startRect = imageEl.getBoundingClientRect();
        const endRect = cartIcon.getBoundingClientRect();

        const flyer = document.createElement('img');
        flyer.src = imageEl.currentSrc || imageEl.src;
        flyer.style.position = 'fixed';
        flyer.style.top = `${startRect.top}px`;
        flyer.style.left = `${startRect.left}px`;
        flyer.style.width = `${startRect.width}px`;
        flyer.style.height = `${startRect.height}px`;
        flyer.style.borderRadius = '50%';
        flyer.style.objectFit = 'cover';
        flyer.style.zIndex = '9999';
        flyer.style.pointerEvents = 'none';
        flyer.style.transition = 'transform 0.7s cubic-bezier(0.55, 0, 1, 0.45), opacity 0.7s ease';
        flyer.style.willChange = 'transform, opacity';
        document.body.appendChild(flyer);

        // Force le navigateur à enregistrer la position de départ avant d'animer
        flyer.getBoundingClientRect();

        const deltaX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
        const deltaY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);

        requestAnimationFrame(() => {
          flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.15)`;
          flyer.style.opacity = '0.3';
        });

        flyer.addEventListener(
          'transitionend',
          () => {
            flyer.remove();
            cartIcon.style.transition = 'transform 0.25s ease';
            cartIcon.style.transform = 'scale(1.25)';
            setTimeout(() => {
              cartIcon.style.transform = 'scale(1)';
            }, 220);
          },
          { once: true }
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
